module.exports = __webpack_public_path__ + "static/media/subscription.ccea592d.png";